import React, { Component } from "react";
import * as prosConnect from "../prodect/ProsConnect";
import {prosNotificationShow, prosPopupClose, prosPopupOpen} from "../prodect/ProsPopup";
import {
    OBJ_STATE_ACT,
    prosLog, UI_LISTED_ELEMENTS_LIMIT
} from "../prodect/ProsConnect";
import {prosLogClearDt} from "../prodect/ProsConnect";
import {prosLogDt} from "../prodect/ProsConnect";
import {setHelpContext} from "../prodect/HelpManager";
import {makeUiMainProjectList} from "../prodect/ProsCommonUi";
import BasicButton, {CancelButton, ConfirmButton} from "../components/BasicButton";
import Spacer from "../components/Spacer";
import DropdownMenu from "../components/DropdownMenu";

export default class SettingMoveProject extends Component
{
    constructor(props) {
        super(props);
        this.state = {
            refreshCounter: 0,

            isLoading: false,
            mainProjectList: [],
            filterProjectForRef: '',
            selectedMainProjectIndex: -1,
        };
    }

    /**
     * This is called when component rendered first time
     */
    async componentDidMount() {
        let project = prosConnect.getActiveProject();
        if (project) {
            prosLogDt('Selected project:', project.getPid());
            this.refreshUi();
        } else {
            prosLog('Project not restored')
        }
        // Get project list with an extra "selection title" with index 0 to filter projects
        let mainProjectList = await makeUiMainProjectList(OBJ_STATE_ACT)
        this.setState({
            isLoading: false,
            mainProjectList: mainProjectList
        })
        setHelpContext('moveProject')
    }

    refreshUi() {
        prosLogClearDt();
        this.setState({
            refreshCounter: this.state.refreshCounter+1,
        }, this.whenStateUpdated);
    }

    getMainProjectMatching(mainProjectList, filterName) {
        let filter = this.state[filterName].toUpperCase()
        return mainProjectList
            .filter((mp, i) => mp.name.toUpperCase().includes(filter) || i === 0)
            .filter((mp) => mp.mainProjectId !== this.props.mainProjectId)
            .filter((mp) => mp.customerGroup !== this.props.customerGroup)
    }

    renderMoveProjectList(filterName) {
        let mainProjectsToChoose = this.getMainProjectMatching(this.state.mainProjectList, filterName)
        const menuItems = [];
        for (const [v] of Object.entries(mainProjectsToChoose)) {
            menuItems.push({
                value: mainProjectsToChoose[v].origIndex,
                text: mainProjectsToChoose[v].name})
        }
        return <DropdownMenu
                values={menuItems}
                checked={true}
                onSelect={retVal=> {
                    this.setState({
                        selectedMainProjectIndex: retVal
                    })
                }}
                className={"width-100"}
                showFilter={menuItems.length > UI_LISTED_ELEMENTS_LIMIT}
            />
    }

    renderMoveProjectButton(){

        if(this.state.selectedMainProjectIndex < 0){
            return null
        }
        return <BasicButton
            label={"Siirrä"}
            icon={"reorder"}
            btnClass={"primary"}
            btnType={"prompt"}
            action={() => {
                prosPopupOpen(this, 'Siirrä projekti',
                    <>
                        <section>
                            <p>Oletko varma että haluat siirtää osaprojektin?</p>
                            <div className={"msg msg-notice"}>
                                <p>Osaprojektin hallinta siirtyy valitsemallesi projektille:</p>
                                <h4>{this.state.mainProjectList[this.state.selectedMainProjectIndex].name}</h4>
                            </div>
                            <Spacer />
                            <p><strong className={"color-2nd"}>Tätä ei voi perua.</strong></p>
                            <p>Toiminnon valmistuminen voi kestää hetken.</p>
                            <p>Osaprojektille tätä hetkeä aikaisemmin luodut linkit lakkaavat toimimasta toiminnon myötä.</p>
                        </section>
                        <footer className={"popup-footer"}>
                            <div className={"btn-set"}>
                                <CancelButton
                                    action={()=> prosPopupClose()}
                                />
                                <ConfirmButton
                                    action={()=> {
                                        prosConnect.moveProjectToAnotherCustomer({
                                            project_pid: this.props.pid,
                                            new_main_proj_id: this.state.mainProjectList[this.state.selectedMainProjectIndex].mainProjectId,
                                        })
                                        prosPopupClose()
                                        prosNotificationShow(this, 'Osaprojekti siirretty.')
                                    }}
                                />
                            </div>
                        </footer>
                    </>
                )
            }}
        />
    }

    render() {
        return <>
                <section className={"create-project create-subproject"}>
                    <div className={"sub-container width-50_xl"}>
                        <h1>Siirrä osaprojekti toiseen projektiin</h1>
                        <p>Osaprojektin siirto toiseen projektiin saman asiakkuuden sisällä onnistuu myös raahaamalla päänäkymän projektilistauksessa.</p>
                        <h2>Valitse kohdeprojekti</h2>
                        <div className={"element-set"}>
                            {this.renderMoveProjectList('filterProjectForRef')}
                            {this.renderMoveProjectButton()}
                        </div>
                    </div>
                </section>
            </>
            // Move history
            // Direct to moved project permissions page?
    }
}
